const styles = () => ({
  root: {
    position: 'relative',
    display: 'inline-block',
    willChange: 'opacity'
  },
  actualText: {
    display: 'inline-block',
    willChange: 'opacity'
  },
  overlay: {
    position: 'absolute',
    left: 0,
    right: 0,
    top: 0,
    overflow: 'hidden',
    display: 'inline-block',
    opacity: 0,
    willChange: 'opacity, contents'
  },
  overlayText: {
    willChange: 'contents'
  },
  hidden: {
    opacity: 0
  },
  animating: {
    '& $actualText': {
      opacity: 0
    },
    '& $overlay': {
      opacity: 1
    }
  }
});

export { styles };
